const contains = (parent, child) => {
	const res = parent.compareDocumentPosition(child);
	return !!(res & Node.DOCUMENT_POSITION_CONTAINED_BY); //bitwise check to see if res includes the contained by bit
};

export {
	contains,
}
